export class SearchTemplateModel {
    filterList:string[] = []
    searchTerm:string;
    operator:boolean = false;
}